export const VEHICLE_DOCUMENT_NAMES = [
  'payment_confirmation',
  'invoice_sales',
  'invoice_purchase',
  'release_report',
  'rental_statement',
  'rdw_vehicle_report',
  'tuv_vehicle_report',
  'report_accept_bedrijfsvoorraad',
  'machtigings_form',
  'credit_invoice',
  'import_report',
  'regplate_foreign',
  'cvo_coc',
  'invoice_export_proforma',
  'bpm_claim',
  'invoice_gmbh_weeze',
  'cmr_gmbh_weeze',
  'german_letter',
  'report_bpm_amount',
  'bvi_email',
  'cmr',
  'cmr_export',
  'cmr_export_goederen_ontvangen',
  'verklaring_nieuw_en_ongebruikt',
  'permanent_registration',
  'exa_confirmed',
  'exa_not_confirmed',
  'order_confirmation',
  'maintenance_history',
  'regplatecard_export',
  'afhaalbewijs',
  'SOH rapport',
  'bpm_request',
  'regplate_part1_part2',
  'verzendbewijs',
  'tdn',
  'other',
];

export const COMPANY_DOCUMENT_NAMES = [
  'kvk',
  'btw_summary',
  'location',
  'credit_check',
  'iban_check',
  'vies_check',
  'id',
  'kvk_btw',
  'bank_card',
  'overig',
];

export const USER_DOCUMENT_NAMES = ['ID_front', 'ID_back', 'copy_bank_card'];
